
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
/*
Base UI includes { ng-zorro } as the base ui library
- Check https://ng.ant.design/docs/introduce/en for getting started with components
- Check /app/sandbox for UI samples
*/
import { NzIconModule } from 'ng-zorro-antd/icon';


/* RICH TEXT EDITOR -- DEMO -- CHANGE AS DESIRED (Quill)*/
import { AngularEditorModule } from '@kolkov/angular-editor';

//Routing Module for the specific View Module



//Shared Module
import { SharedComponentsModule } from '../../shared-components/shared-components.module'
import { SharedServicesModule } from '../../shared-services/shared-services.module'

// count up animation
import { CountUpModule } from 'countup.js-angular2';
import { TransactionDetailsComponent } from './transaction-details/transaction-details.component';
import { TransactionRoutingModule } from './transaction-routing.module';
import { NgZorroAntdModule } from 'app/ng-zorro.module';


const _components = [TransactionDetailsComponent]

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularEditorModule,
    NgZorroAntdModule,
    NzIconModule,
    SharedComponentsModule,
    SharedServicesModule,
    TransactionRoutingModule,
    CountUpModule,
  ],
  declarations: [..._components],
  exports: [..._components]
})
export class TransactionModule { }
